import { Button as BaseButton } from "@mui/base"
import CircularProgress from "@mui/material/CircularProgress"
import { forwardRef } from "react"
import { twMerge } from "tailwind-merge"

import type { ButtonProps } from "./button.schema"
import { buttonSchema } from "./button.schema"
import buttonVariants from "./buttonVariant"

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { appearance, size, variant, disabled } = buttonSchema.parse(props)
  const { endIcon, startIcon, loading, ...rest } = props

  const isDisabled = disabled || loading
  const classes = buttonVariants({
    size,
    variant,
    appearance,
    disabled: isDisabled,
  })

  return (
    <BaseButton {...rest} ref={ref} className={twMerge(classes, props.className)} disabled={isDisabled}>
      {startIcon && !loading && <span>{startIcon}</span>}
      {props.value || props.children}
      {loading && (
        <span data-testid='button-loader'>
          <CircularProgress size={20} />
        </span>
      )}
      {endIcon && !loading && <span>{endIcon}</span>}
    </BaseButton>
  )
})

Button.displayName = "Button"

export default Button
